export default __webpack_public_path__ + "static/media/uncheck_circle.a29a346c.svg";